import { db } from '../../../config/firebase';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';

// FIX: getCountFromServer + getDocs eran 2 round-trips.
// getDocs con limit(1) obtiene existencia Y datos en 1 sola consulta.
export const checkSurveyExists = async (urlId) => {
  if (!urlId) return { exists: false, surveyId: null, data: null };
  try {
    const snap = await getDocs(
      query(collection(db, 'surveys'), where('urlId', '==', urlId), limit(1))
    );
    if (snap.empty) return { exists: false, surveyId: null, data: null };
    const docSnap = snap.docs[0];
    return { exists: true, surveyId: docSnap.id, data: { id: docSnap.id, ...docSnap.data() } };
  } catch (error) {
    console.error('Error checking if survey exists:', error);
    return { exists: false, surveyId: null, data: null };
  }
};

// FIX: delega en checkSurveyExists en lugar de hacer su propia query.
// Antes: surveyExistsQuick + checkSurveyExists = 3 queries en el path "existe".
// Ahora: 1 sola query sin importar el resultado.
export const surveyExistsQuick = async (urlId) => {
  const { exists } = await checkSurveyExists(urlId);
  return exists;
};